import Cookies from 'js-cookie'

// token
const TokenKey = 'token'

export function getToken() {
  return localStorage.getItem(TokenKey) || '';
}

export function getVirtualStatus() {
  return localStorage.getItem('virtualStatus') == 1 ? 'NO' : 'YES';
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token);
}

export function removeToken() {
  return localStorage.removeItem(TokenKey);
}

// userinfo
const userName = 'userName'

export function getUserName() {
  return Cookies.get(userName)
}

export function setUserName(user) {
  return Cookies.set(userName, user)
}

export function removeUserName() {
  return Cookies.remove(userName)
}